import apiManagerRoom from "api/manager-meeting";
import { DIALOG_ID } from "components/Dialog/constant";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { TYPE_FILES, TYPE_FILES_EVENT } from "constants/files";
import { convertTypeFile, totalSizeFiles } from "components/common/file/function";
import { generateUniqueString } from "../functions";
const { toastError, setOpenDialogCC, setCloseDialogCC } = require("utils/helpers");

const useHandleFile = () => {
    const MAX_TOTAL_SIZE = 26214400;
    const { t } = useTranslation('pgMeeting')
    const [files, setFiles] = useState([]);
    const [filesRoomGetted, setFilesRoomGetted] = useState([]);
    const [filesUpload, setFilesUpload] = useState({});
    const [hasAttachFiles, sethasAttachFiles] = useState(false);
    const [tmpInputFiles, setTmpInputFiles] = useState([]);
    const [slot, setSlot] = useState('');
    const [roomId, setRoomId] = useState();
    const { pathname } = useLocation();
    const [isUpdating, setIsUpdating] = useState(false);

    const handleUploadOneFile = (e) => {
        // phuva: upload file from input
        let newFiles = [];
        let newTmpFiles = [];
        const inputFiles = e.target.files; // get files from input
        // const srcBI = `url(${ URL.createObjectURL(e.target.files[0])})`
        const pathBI = URL.createObjectURL(e.target.files[0])
        // validate max length files
        if (files.length + inputFiles.length > 10) {
            toastError(t('attachFiles.validateMaxLength'));
            return;
        }

        for (let i = 0; i < inputFiles.length; i++) {
            let inputFile = {
                name: inputFiles[i]?.name,
                size: inputFiles[i]?.size,
                type: convertTypeFile(inputFiles[i]?.name),
                src: pathBI
            };

            if (!TYPE_FILES_EVENT[inputFile.type]) {
                toastError(t('attachFiles.validateUnSupportEvent')); // validate unsupport files
                return;
            }

            if (!files.some((f) => f.name === inputFile.name)) {
                newFiles.push(inputFile); // ok
                sethasAttachFiles(true);
            } else {

                toastError(t('attachFiles.fileEists'));
                // let tmpFile = inputFiles[i];
                // newTmpFiles.push(tmpFile);
            }
        }
        // validate size
        if (totalSizeFiles(files) + totalSizeFiles(newFiles) > MAX_TOTAL_SIZE) {
            toastError(t('attachFiles.validateMaxSize'));
            return;
        }
        let _filesUpload = filesUpload;

        if (newTmpFiles.length > 0) {
            let arrayInputFiles = Array.from(inputFiles);
            newTmpFiles.forEach((f) => {
                arrayInputFiles = arrayInputFiles.filter((p) => p.name !== f.name);
            });
            let totalFiles = Object.keys(filesUpload).length + arrayInputFiles.length;
            let len = Object.keys(filesUpload).length;
            for (let i = len; i < totalFiles; i++) {
                _filesUpload[i] = arrayInputFiles[i - len];
            }
        } else {
            let totalFiles = Object.keys(filesUpload).length + Object.keys(inputFiles).length;
            let len = Object.keys(filesUpload).length;

            for (let i = len; i < totalFiles; i++) {
                _filesUpload[i] = Object.values(inputFiles)[i - len];
            }
        }
        // update files upload
        setFilesUpload(_filesUpload);
        setFiles([...newFiles]);
        // clear input upload files
        e.target.value = null;
    };

    const uploadFileWhenCreate = (slot, data) => {
        return apiManagerRoom.uploadFileMeeting(slot, data);
    };

    const uploadFile = async (roomId, data) => {
        return await apiManagerRoom.uploadFile(roomId, data);
    };

    const deleteFilesWhenCreate = (fileNames, slot) => {
        return apiManagerRoom.deleteFileWhenCreate({ fileNames, slot });
    };

    const deleteFiles = async (fileNames, roomId) => {
        if (!fileNames.length) return null;
        return await apiManagerRoom.deleteFile({
            file_names: fileNames,
            room_id: roomId
        });
    };

    const uploadFilesToRoom = async (roomId, newFilesUpload) => {
        let formData = new FormData();

        for (const property in newFilesUpload) {
            formData.append('files', newFilesUpload[property]);
            formData.append('names', [newFilesUpload[property].name]);
        }

        try {
            const res = await uploadFile(roomId, formData)

            if (res.status === 200) {

            } else {
                toastError(t('attachFiles.errorUploadFile'));
            }
        } catch (err) {
            if (err) {
                toastError(t('attachFiles.errorUploadFile'));
                setFiles([]);
                setFilesUpload([]);
            }
        }
    };

    const handleUploadFile = (e) => {
        // anhnt653: upload file from input
        let newFiles = [];
        let newTmpFiles = [];
        const inputFiles = e.target.files; // get files from input
        const srcBI = `url(${URL.createObjectURL(e.target.files[0])})`
        // validate max length files
        if (files.length + inputFiles.length > 10) {
            toastError(t('attachFiles.validateMaxLength'));
            return;
        }

        for (let i = 0; i < inputFiles.length; i++) {
            let inputFile = {
                name: inputFiles[i]?.name,
                size: inputFiles[i]?.size,
                type: convertTypeFile(inputFiles[i]?.name),
                src: srcBI
            };
            if (!TYPE_FILES[inputFile.type]) {
                toastError(t('attachFiles.validateUnSupport')); // validate unsupport files
                return;
            }
            if (!files.some((f) => f.name === inputFile.name)) {
                newFiles.push(inputFile); // ok
                sethasAttachFiles(true);
            } else {
                let tmpFile = inputFiles[i];
                newTmpFiles.push(tmpFile);
            }
        }

        // validate size
        if (totalSizeFiles(files) + totalSizeFiles(newFiles) > MAX_TOTAL_SIZE) {
            toastError(t('attachFiles.validateMaxSize'));
            return;
        }

        let _filesUpload = filesUpload;
        let _newFilesUpload = {}

        if (newTmpFiles.length > 0) {
            setTmpInputFiles(newTmpFiles);
            let arrayInputFiles = Array.from(inputFiles);

            newTmpFiles.forEach((f) => {
                arrayInputFiles = arrayInputFiles.filter((p) => p.name !== f.name);
            });

            let totalFiles = Object.keys(filesUpload).length + arrayInputFiles.length;
            let len = Object.keys(filesUpload).length;

            for (let i = len; i < totalFiles; i++) {
                _filesUpload[i] = arrayInputFiles[i - len];
                _newFilesUpload[i - len] = arrayInputFiles[i - len];
            }

        } else {
            let totalFiles = Object.keys(filesUpload).length + Object.keys(inputFiles).length;
            let len = Object.keys(filesUpload).length;

            for (let i = len; i < totalFiles; i++) {
                _filesUpload[i] = Object.values(inputFiles)[i - len];
                _newFilesUpload[i - len] = Object.values(inputFiles)[i - len];
            }
        }

        if (Object.keys(_newFilesUpload).length) {
            if (pathname.includes('update')) {
                setIsUpdating(true)
                uploadFilesToRoom(roomId, _newFilesUpload)
                    .then(res => {
                        setFilesUpload(_filesUpload);
                        setFiles([...files, ...newFiles]);
                    })
                    .catch(error => {
                        toastError(t('attachFiles.errorUploadFile'));
                    })
                    .finally(() => {
                        setIsUpdating(false)
                    });
            } else {
                let formData = new FormData();

                for (const property in _newFilesUpload) {
                    formData.append('files', _newFilesUpload[property]);
                    formData.append('names', [_newFilesUpload[property].name]);
                }

                let _slot = slot;
                if (!slot) {
                    _slot = generateUniqueString();
                    setSlot(_slot);
                }

                setIsUpdating(true)
                uploadFileWhenCreate(_slot, formData)
                    .then((res) => {
                        if (res.status === 200) {
                            // update files upload
                            setFilesUpload(_filesUpload);
                            setFiles([...files, ...newFiles]);
                        } else {
                            toastError(t('attachFiles.errorUploadFile'));
                        }
                    })
                    .catch((err) => {
                        if (err) {
                            toastError(t('attachFiles.errorUploadFile'));
                        }
                    })
                    .finally(() => {
                        setIsUpdating(false)
                    });
            }
        }

        // clear input upload files
        e.target.value = null;

    };

    const onDeleteFile = async (fileName, fileId) => {
        const newFiles = files.filter((file) => file.name !== fileName);
        let newFilesUpload = filesUpload;

        if (pathname.includes('update')) {
            let _fileNamesGetted = filesRoomGetted.map(file => file.name);

            if (_fileNamesGetted.includes(fileName) && fileId) {
                setFiles(newFiles);
                sethasAttachFiles(true);
            } else {
                for (const property in newFilesUpload) {
                    if (newFilesUpload[property].name === fileName) {
                        try {
                            setIsUpdating(true)
                            await deleteFiles([fileName], roomId);
                            delete newFilesUpload[property]
                            setFiles(newFiles);
                            setFilesUpload(newFilesUpload);
                            if(Object.keys(filesUpload).length === 0){
                                if(files.length !== filesRoomGetted.length){
                                    sethasAttachFiles(true)
                                } else {
                                    sethasAttachFiles(false);
                                }
                            } else {
                                sethasAttachFiles(true)
                            }

                        } catch (error) {
                            toastError(t('attachFiles.errorDeleteFile'));
                        } finally {
                            setIsUpdating(false)
                        }

                    };
                }
            }

        } else {
            for (const property in newFilesUpload) {
                if (newFilesUpload[property].name === fileName) {
                    setIsUpdating(true)
                    deleteFilesWhenCreate([fileName], slot)
                        .then(r => {
                            delete newFilesUpload[property]
                            setFiles(newFiles);
                            setFilesUpload(newFilesUpload);
                            sethasAttachFiles(Object.keys(filesUpload).length !== 0 ? true : false);
                        })
                        .catch(error => {
                            toastError(t('attachFiles.errorDeleteFile'));
                        })
                        .finally(() => {
                            setIsUpdating(false)
                        })
                };
            }
        }
    };

    const handleOverrideFiles = async () => {
        setCloseDialogCC();

        let arrayFilesUpload = Object.values(filesUpload);
        let arrayFiles = files;

        let arrayFilesNameDeleted = tmpInputFiles.map(f => f.name);
        let arrayFilesUploadNew = []

        if (pathname.includes('update')) {
            let arrayFileNamesHasId = arrayFiles.filter(file => file?.id).map(file => file.name);
            let arrayFileNameNoId = arrayFiles.filter(file => !file?.id).map(file => file.name);

            let tmpInputFilesHasId = tmpInputFiles.filter(file => arrayFileNamesHasId.includes(file.name));
            let tmpInputFilesNoId = tmpInputFiles.filter(file => arrayFileNameNoId.includes(file.name));

            arrayFilesNameDeleted = tmpInputFilesNoId.length > 0 ? tmpInputFilesNoId.map(file => file?.name) : [];

            try {
                setIsUpdating(true)
                await deleteFiles(arrayFilesNameDeleted, roomId);
                sethasAttachFiles(true)
                tmpInputFiles.forEach((f) => {
                    let index = arrayFiles.findIndex((fi) => f.name === fi.name);
                    let indexUpload = arrayFilesUpload.findIndex((fi) => f.name === fi.name);
                    arrayFiles.splice(index, 1);
                    indexUpload >=0 && arrayFilesUpload.splice(indexUpload, 1);
                });

                let formData = new FormData();
                let objectFilesUploadNew = { ...tmpInputFilesHasId, ...tmpInputFilesNoId }

                for (const property in objectFilesUploadNew) {
                    formData.append('files', objectFilesUploadNew[property]);
                    formData.append('names', [objectFilesUploadNew[property].name]);
                }
                try {
                    const res = await uploadFile(roomId, formData)
                    if (res.status === 200) {
                        tmpInputFiles.forEach((f) => {
                            arrayFiles.push(f);
                            arrayFilesUpload.push(f);

                            // update files upload
                            setFiles(arrayFiles);
                            setFilesUpload({ ...arrayFilesUpload });
                            setTmpInputFiles([])
                        });
                    } else {
                        toastError(t('attachFiles.errorUploadFile'));
                    }
                } catch (err) {
                    if (err) {
                        toastError(t('attachFiles.errorUploadFile'));
                    }
                } finally{
                    setIsUpdating(false)
                }
            } catch (error) {
                toastError(t('attachFiles.errorUploadFile'));
            } finally {
            }
        } else {
            setIsUpdating(true)
            deleteFilesWhenCreate(arrayFilesNameDeleted, slot)
                .then(r => {
                    tmpInputFiles.forEach((f) => {
                        let index = arrayFiles.findIndex((fi) => f.name === fi.name);
                        let indexUpload = arrayFilesUpload.findIndex((fi) => f.name === fi.name);
                        arrayFiles.splice(index, 1);
                        indexUpload >= 0 && arrayFilesUpload.splice(indexUpload, 1);
                        arrayFilesUploadNew.push(f)
                    });

                    let formData = new FormData();
                    let objectFilesUploadNew = { ...arrayFilesUploadNew }

                    for (const property in objectFilesUploadNew) {
                        formData.append('files', objectFilesUploadNew[property]);
                        formData.append('names', [objectFilesUploadNew[property].name]);
                    }

                    uploadFileWhenCreate(slot, formData)
                        .then((res) => {
                            if (res.status === 200) {
                                tmpInputFiles.forEach((f) => {
                                    arrayFiles.push(f);
                                    arrayFilesUpload.push(f);
                                });

                                // update files upload
                                setFiles(arrayFiles);
                                setFilesUpload({ ...arrayFilesUpload });
                                setTmpInputFiles([])
                            } else {
                                toastError(t('attachFiles.errorUploadFile'));
                            }
                        })
                        .catch((err) => {
                            if (err) {
                                toastError(t('attachFiles.errorUploadFile'));
                            }
                        })
                        .finally(() => {
                            setIsUpdating(false)

                        });
                })
                .catch(error => {
                    toastError(t('attachFiles.errorDeleteFile'));
                })
                .finally(() => {
                })
        }
    };

    useEffect(() => {
        if (tmpInputFiles.length > 0 && !isUpdating) {
            // tmpInputFiles.src =  URL.createObjectURL(tmpInputFiles[0])
            let str = '';
            tmpInputFiles.forEach((f) => (str += f.name + ', '));
            setTimeout(() => {
                setOpenDialogCC({ id: DIALOG_ID.CONFIRM, props: { title: t('attachFiles.validateIsExisted'), contentText: t('attachFiles.contentOverride', { count: tmpInputFiles.length, names: str.slice(0, str.length - 2) }), onClick: handleOverrideFiles } })
            }, 100);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tmpInputFiles, isUpdating]);

    return {
        files,
        setFiles,
        handleUploadFile,
        onDeleteFile,
        filesUpload,
        setFilesUpload,
        filesRoomGetted,
        setFilesRoomGetted,
        hasAttachFiles,
        sethasAttachFiles,
        handleUploadOneFile,
        slot,
        setRoomId,
        isUpdating
    }
}

export default useHandleFile;